import 'css-chunksrc/client/common/treeToggle/controls/styles.scss';export default {
  "controls": "_controls_1gymy_1"
};